/* CRO BF-S3 2026-10-27 · cart add-on rows (snippets/bf-cart-addons.liquid).
   Adds the chosen variant the same way product-form.js does (no X-Requested-With header,
   so a Bundles set already in the cart is kept), then repaints the drawer from the
   returned sections. On /cart the page reloads so every section shows the new cart. */
(function () {
  if (window.bfsCart) return; window.bfsCart = 1;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bfs-add]');
    if (!btn || btn.disabled) return;
    var row = btn.closest('.bfs-add'), sel = row.querySelector('select'), err = row.querySelector('.bfs-add__err');
    var id = sel ? sel.value : btn.dataset.id;
    var opt = sel && sel.selectedOptions[0];
    if (!id || (opt && opt.disabled)) return;
    var drawer = document.querySelector('cart-drawer');
    var onCart = !!document.querySelector('cart-items:not(cart-drawer-items)');
    var fd = new FormData(); fd.append('id', id); fd.append('quantity', '1');
    if (drawer && !onCart) {
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }
    var cfg = fetchConfig('javascript'); delete cfg.headers['Content-Type']; delete cfg.headers['X-Requested-With']; cfg.body = fd;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true'); err.hidden = true;
    fetch(window.routes.cart_add_url, cfg).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { err.textContent = res.description || res.message || 'Could not add this'; err.hidden = false; btn.disabled = false; btn.removeAttribute('aria-busy'); return; }
      if (onCart || !drawer) { window.location.reload(); return; }
      if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bf-addon', productVariantId: id, cartData: res });
      drawer.renderContents(res);
    }).catch(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
  });
})();
